// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQv0sPTRmtUhW7Fn9jNrAk572hw2_XFJw",
  authDomain: "umd-wildfire-research.firebaseapp.com",
  projectId: "umd-wildfire-research",
  storageBucket: "umd-wildfire-research.appspot.com",
  messagingSenderId: "720270791772",
  appId: "1:720270791772:web:99acd69e5153596d118299",
  measurementId: "G-9E1QFLVRZF",
  databaseURL: "https://umd-wildfire-research-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
const analytics = getAnalytics(app);